import {
  LockOutlined,
  PersonOutlineOutlined,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { memo, useState } from "react";
import { useHistory } from "react-router-dom";
import { basicLogin } from "../../api/users/configApi";
import storage from "../../utils/storage";
import { useStyles } from "./styles";

export const InitialLogin = () => {
  const classes = useStyles();
  const history = useHistory();
  const [state, setState] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showInvalidUser, setShowInvalidUser] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setShowInvalidUser(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await basicLogin(state);
      if (response?.status === 200) {
        storage.setItem("basicLogin", state);
        history.push("/intial-onboarding");
      }
    } catch (e) {}
    setShowInvalidUser(true);
  };

  return (
    <Box sx={{ width: "65%" }}>
      <Box className={classes.warningView}>
        {showInvalidUser ? (
          <Typography gutterBottom={true}>
            Invalid Username or Password.
          </Typography>
        ) : (
          <>
            <Typography>
              Application is not yet fully configured yet.
            </Typography>
            <Typography>
              <b>Login to complete configuration</b>
            </Typography>
          </>
        )}
      </Box>
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <TextField
          margin="normal"
          required
          fullWidth
          label="Username"
          name="email"
          variant="outlined"
          value={state.email}
          autoFocus
          onChange={handleChange}
          InputProps={{
            startAdornment: (
              <InputAdornment>
                <PersonOutlineOutlined />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          variant="outlined"
          value={state.password}
          autoComplete="current-password"
          type={showPassword ? "text" : "password"}
          onChange={handleChange}
          InputProps={{
            startAdornment: (
              <InputAdornment>
                <LockOutlined />
              </InputAdornment>
            ),
            endAdornment: (
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
        />

        <Button
          className={classes.loginBtn}
          type="submit"
          fullWidth
          disabled={!(state.email && state.password)}
          variant="contained"
        >
          Sign In
        </Button>
      </Box>
    </Box>
  );
};

export default memo(InitialLogin);
